import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DecidoEvaluationService } from 'src/app/core/decido-evaluation.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { GaranLogService } from 'src/app/core/garan-log.service';
import { UtilsService } from 'src/app/core/utils.service';

@Component({
  selector: 'app-orders-decido-dialog',
  templateUrl: './orders-decido-dialog.component.html',
  styleUrls: ['./orders-decido-dialog.component.scss'],
})
export class OrdersDecidoDialogComponent {
  decido_evaluation_id?: string;
  buyer_id?: string;
  is_evaluation_read_running: boolean = true;
  decido_evaluation?: any;

  constructor(
    private dialog_ref: MatDialogRef<OrdersDecidoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private decido_evaluation_service: DecidoEvaluationService,
    private error_service: ErrorService,
    private garan_log_service: GaranLogService,
    private utils_service: UtilsService,
  ) {
    this.decido_evaluation_id = data.decido_evaluation_id;
    this.buyer_id = data.buyer_id;
  }

  ngOnInit(): void {
    if (this.buyer_id) {
      this.createGaranLog(this.buyer_id);
    }

    if (this.decido_evaluation_id && this.buyer_id) {
      this.readDecidoEvaluation(this.decido_evaluation_id, this.buyer_id);
    }
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  readDecidoEvaluation(qinetic_position_id: string, buyer_id: string): void {
    this.is_evaluation_read_running = true;
    this.decido_evaluation_service.read(qinetic_position_id, buyer_id).subscribe({
      next: response => {
        this.decido_evaluation = response.data;
        this.is_evaluation_read_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_evaluation_read_running = false;
      },
    });
  }

  createGaranLog(buyer_id: string): void {
    const admin_email = this.utils_service.getProfileEmail();
    this.garan_log_service.create(buyer_id, admin_email).subscribe({
      next: () => {},
      error: () => {},
    });
  }
}
